import Marquee from "react-fast-marquee";
import { brandLogos } from "../../assets/dummyData";
import { Box } from "@mui/material";

const BrandLogoSlider = () => {
  return (
    <Box
      sx={{
        borderRadius: "10px",
        backgroundColor: "#ffffff",
        border: "1px solid #e8e8e8",
        mx: { xs: 2, sm: 3 },
        mb: { xs: 3, sm: 4 },
        py: { xs: 1.8, sm: 2 },
        overflow: "hidden",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",
      }}
    >
      <Marquee gradient={false} speed={35} pauseOnHover={true} direction="left">
        {brandLogos.map((logo, i) => (
          <Box
            key={i}
            sx={{
              mx: { xs: 2.5, sm: 3.5 },
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              opacity: 0.75,
              transition: "all 0.3s ease",
              "&:hover": {
                opacity: 1,
                transform: "scale(1.08)",
              },
            }}
          >
            <img
              src={logo}
              alt="brand"
              style={{
                width: "100px",
                height: "46px",
                objectFit: "contain",
                filter: "grayscale(20%)",
              }}
            />
          </Box>
        ))}
      </Marquee>
    </Box>
  );
};

export default BrandLogoSlider;
